// extracted by mini-css-extract-plugin
module.exports = {"search":"_1-Qy7sBT","schoolList":"_2wuOJw4u","active":"_1Y5JbzT6","schoolName":"_3lVaYiib","result":"_35BdxlZT"};